import { GetOrgSettings, GetServicerSettings, GetPublicServicerSettings, GetPublicPartnerSettings } from '../gql/leadGenQueries.gql'
import apolloClient from '~/util/apolloClient'
const { provider } = apolloClient()

export default {
  fetchOrgSettings (context) {
    const orgGuid = context.state.orgGuid
    const orgType = context.state.orgType
    const orgId = context.state.orgId
    if (!orgType || !(orgId || orgGuid)) return

    return provider.clients.defaultClient.query({
      query: GetOrgSettings,
      variables: { orgGuid, orgType, orgId }
    }).then(({ data: { publicData: { organization } } }) => {
      if (organization) {
        context.commit('setSettings', {
          landingPageTitle: organization.lead_gen_setting_landing_page_title_text || null,
          submissionPageBodyText: organization.lead_gen_setting_submission_page_body_text || null,
          prequalHardCreditAllowed: organization.lead_gen_setting_prequal_hard_credit_allowed || false,
          purchaseFlow: organization.lead_gen_setting_purchase_flow || false,
          refinanceFlow: organization.lead_gen_setting_refinance_flow || false,
          prequalFlow: organization.lead_gen_setting_prequal_flow || false,
          autoRunLpa: organization.lead_gen_setting_auto_run_lpa || false,
          autoRunDu: organization.lead_gen_setting_auto_run_du || false,
          autoRunCredit: organization.lead_gen_setting_auto_run_credit || false,
          conversationalFlow: organization.lead_gen_setting_conversational_flow || false,
          orgIcon: organization.effective_logo_url || null,
          orgAppIcon: organization.effective_app_icon_url || null,
          name: organization.name || null,
          hasAusIntegration: organization.has_du || organization.has_lpa || false,
          hasCreditIntegration: organization.has_hard_credit || organization.has_soft_credit || false
        })
      } else {
        context.commit('reinitializeOrgSettings')
      }
    }).catch(() => {
      context.commit('reinitializeOrgSettings')
    })
  },
  fetchServicerSettings (context) {
    const servicerId = context.state.orgId
    if (!servicerId) return

    provider.clients.defaultClient.query({
      query: GetServicerSettings,
      variables: { id: servicerId }
    }).then(({ data: { servicer_profile } }) => {
      // eslint-disable-next-line babel/camelcase
      if (servicer_profile) {
        context.commit('setSettings', {
          orgIcon: servicer_profile.effective_company_logo_url,
          orgAppIcon: servicer_profile.effective_app_icon_url,
          servicerImageUrl: servicer_profile.profile_image_url,
          servicerInitials: servicer_profile.full_name.split(' ').map(name => name[0]).join(''),
          landingPageTitle: servicer_profile.lead_gen_setting_landing_page_title_text,
          submissionPageBodyText: servicer_profile.lead_gen_setting_submission_page_body_text || null,
          prequalHardCreditAllowed: servicer_profile.lead_gen_setting_prequal_hard_credit_allowed || false,
          purchaseFlow: servicer_profile.lead_gen_setting_purchase_flow || false,
          refinanceFlow: servicer_profile.lead_gen_setting_refinance_flow || false,
          prequalFlow: servicer_profile.lead_gen_setting_prequal_flow || false,
          autoRunLpa: servicer_profile.lead_gen_setting_auto_run_lpa || false,
          autoRunDu: servicer_profile.lead_gen_setting_auto_run_du || false,
          autoRunCredit: servicer_profile.lead_gen_setting_auto_run_credit || false,
          conversationalFlow: servicer_profile.lead_gen_setting_conversational_flow || false,
          hasAusIntegration: servicer_profile.has_du || servicer_profile.has_lpa || false,
          hasCreditIntegration: servicer_profile.has_hard_credit || servicer_profile.has_soft_credit || false
        })
      } else {
        context.commit('reinitializeServicerSettings')
      }
    }).catch(() => {
      context.commit('reinitializeServicerSettings')
    })
  },
  fetchPublicServicerAndPartnerSettings (context) {
    const sac = context.state.sac
    if (!sac) return

    provider.clients.defaultClient.query({
      query: GetPublicServicerSettings,
      variables: { sac }
    }).then(({ data: { publicData: { servicer_profile } } }) => {
      // eslint-disable-next-line babel/camelcase
      if (servicer_profile) {
        context.commit('setSettings', {
          orgIcon: servicer_profile.effective_company_logo_url,
          orgAppIcon: servicer_profile.effective_app_icon_url,
          servicerImageUrl: servicer_profile.profile_image_url,
          servicerInitials: servicer_profile.full_name.split(' ').map(name => name[0]).join(''),
          landingPageTitle: servicer_profile.lead_gen_setting_landing_page_title_text,
          submissionPageBodyText: servicer_profile.lead_gen_setting_submission_page_body_text || null,
          prequalHardCreditAllowed: servicer_profile.lead_gen_setting_prequal_hard_credit_allowed || false,
          purchaseFlow: servicer_profile.lead_gen_setting_purchase_flow || false,
          refinanceFlow: servicer_profile.lead_gen_setting_refinance_flow || false,
          prequalFlow: servicer_profile.lead_gen_setting_prequal_flow || false,
          autoRunLpa: servicer_profile.lead_gen_setting_auto_run_lpa || false,
          autoRunDu: servicer_profile.lead_gen_setting_auto_run_du || false,
          autoRunCredit: servicer_profile.lead_gen_setting_auto_run_credit || false,
          conversationalFlow: servicer_profile.lead_gen_setting_conversational_flow || false,
          hasAusIntegration: servicer_profile.has_du || servicer_profile.has_lpa || false,
          hasCreditIntegration: servicer_profile.has_hard_credit || servicer_profile.has_soft_credit || false
        })
      } else {
        context.commit('reinitializeServicerSettings')
      }
    }).catch(() => {
      context.commit('reinitializeServicerSettings')
    })

    context.dispatch('fetchPublicPartnerSettings', context)
  },
  fetchPublicPartnerSettings (context) {
    const sac = context.state.sac
    if (!sac) return

    provider.clients.defaultClient.query({
      query: GetPublicPartnerSettings,
      variables: { sac }
    }).then(({ data: { publicData: { partner } } }) => {
      if (partner) {
        context.commit('setPartnerSettings', {
          partnerImageUrl: partner.profile_image_url,
          partnerInitials: partner.full_name.split(' ').map(name => name[0]).join('')
        })
      } else {
        context.commit('reinitializePartnerSettings')
      }
    }).catch(() => {
      context.commit('reinitializePartnerSettings')
    })
  },
  clearSacData (context) {
    context.commit('setSac', null)
    context.commit('reinitializeServicerSettings')
    context.commit('reinitializePartnerSettings')
  }
}
